import * as React from "react";
import { Container, Col, Row, Image } from 'react-bootstrap';
import Scrollspy from "react-scrollspy";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import Imageicon1 from "../images/icon/aws-icon-1.svg";
import Imageicon2 from "../images/icon/aws-icon-2.svg";
import Imageicon3 from "../images/icon/aws-icon-3.svg";

import Imageicon4 from "../images/icon/aws-icon-4.svg";
import Imageicon5 from "../images/icon/aws-icon-5.svg";
import Imageicon6 from "../images/icon/aws-icon-6.svg";
import Imageicon7 from "../images/icon/aws-icon-7.svg";
import Imageicon8 from "../images/icon/aws-icon-8.svg";
import Imageicon9 from "../images/icon/aws-icon-9.svg";
import Imageicon10 from "../images/icon/aws-icon-10.svg";
import Imageicon11 from "../images/icon/aws-icon-11.svg";
import Imageicon12 from "../images/icon/aws-icon-12.svg";
import Imageicon13 from "../images/icon/aws-icon-13.svg";
import Imageicon14 from "../images/icon/aws-icon-14.svg";
import { Link } from "gatsby";


const Usecaseaws = ({
  title = " <span class='text-primary'>Driving results with AWS:</span> Practical use cases we’ve solved",
  description = " Explore a variety of challenges in AWS that our AWS certified experts have resolved for clients, delivering efficient, scalable, and cost-effective solutions.",
  sectionClass = 'bg-white',
}) => {

  const ReliableOffshore = [
    {

      title: "Optimizing large file imports with AWS Lambda & SQS",
      tabId: "awstab1",
      des: "The client’s application struggled with importing large files directly into the database. The existing server-based API caused:",
      list: [
        {
          listname: 'Server overload during file processing'
        },
        {
          listname: 'Slow request completion, leading to delays and timeouts'
        },
        {
          listname: 'Poor user experience due to system slowdowns'
        },
      ],
      solutiondes: "We migrated the file import process to a serverless architecture using AWS Lambda and Amazon SQS:",
      solitionlist: [
        {
          listname: '<span class="fw-medium">01 File Upload : </span> Frontend uploads files to AWS Lambda instead of the server.'
        },
        {
          listname: '<span class="fw-medium">02 Processing & Chunking : </span> Lambda splits files into smaller chunks for manageable processing.'
        },
        {
          listname: '<span class="fw-medium">03 Queue Management : </span> Chunks are sent to Amazon SQS to prevent system overload.'
        },
        {
          listname: '<span class="fw-medium">04 Database Entry : </span> Another Lambda function retrieves chunks from SQS and inserts them into Amazon RDS in parallel.'
        },
      ],
      resultlist: [
        {
          listname: '80% faster file processing with no server overload'
        },
        {
          listname: 'Scalable solution handling files of any size.'
        },
        {
          listname: 'Cost savings via on-demand Lambda usage'
        },
        {
          listname: 'Improved user experience with smooth, non-blocking imports'
        },
      ],
      service: [
        {
          imgicon: Imageicon3,
          listname: "AWS Lambda",
          width: 57, height: 60
        },
        {
          imgicon: Imageicon2,
          listname: "Amazon SQS",
          width: 49, height: 60
        },
        {
          imgicon: Imageicon1,
          listname: "Amazon RDS",
          width: 60, height: 60

        }
      ]
    },
    {
      title: "Scalable PDF generation with AWS Lambda & S3",
      tabId: "awstab2",
      des: "The client’s application struggled with generating dynamic PDF invoices, causing:",
      list: [
        {
          listname: 'Server overload with simultaneous PDF requests'
        },
        {
          listname: 'Slow database queries delaying processing'
        },
        {
          listname: 'Performance issues with multiple invoice generations'
        },
      ],
      solutiondes: "We migrated the PDF generation process to a serverless architecture using AWS Lambda and Amazon S3:",
      solitionlist: [
        {
          listname: '<span class="fw-medium">01 Data Processing : </span> AWS Lambda retrieves invoice data from Amazon RDS and performs calculations.'
        },
        {
          listname: '<span class="fw-medium">02 PDF Generation : </span> Lambda dynamically creates PDFs using processed data.'
        },
        {
          listname: '<span class="fw-medium">03 Cloud Storage : </span> Generated PDFs are securely stored in Amazon S3 for scalability and easy access.'
        },
        {
          listname: '<span class="fw-medium">04 Instant Access : </span> Lambda returns an S3 URL for immediate PDF download via the frontend.'
        },
      ],


      resultlist: [
        {
          listname: 'Faster processing with on-demand Lambda execution'
        },
        {
          listname: 'Cost-effective scalability without extra server load'
        },
        {
          listname: 'Improved reliability for handling multiple PDF requests'
        },
        {
          listname: 'Secure, cloud-based storage ensuring high availability'
        },
      ],
      service: [
        {
          imgicon: Imageicon3,
          listname: "AWS Lambda",
          width: 57, height: 60

        },
        {
          imgicon: Imageicon1,
          listname: "Amazon RDS",
          width: 60, height: 60
        },
        {
          imgicon: Imageicon5,
          listname: "Amazon S3",
          width: 50, height: 60
        }
      ]
    },
    {
      title: "Automating Infrastructure Deployment with AWS CDK",
      tabId: "awstab3",
      des: "Manual cloud infrastructure setup was time-consuming and error-prone, involving:",
      list: [
        {
          listname: 'VPC configuration with subnets'
        },
        {
          listname: 'Load balancers, EKS clusters, and services'
        },
        {
          listname: 'CI/CD pipelines and EC2 setup for multiple environments (UAT, production, client-specific)'
        },
      ],
      solutiondes: "We implemented AWS Cloud Development Kit (CDK) for Infrastructure as Code (IaC):",
      solitionlist: [
        {
          listname: '<span class="fw-medium">01 Infrastructure as Code : </span> Built a reusable AWS CDK project defining VPC, subnets, EKS clusters, load balancers, and pipelines.'
        },
        {
          listname: '<span class="fw-medium">02 One-Click Deployment : </span> A single cdk deploy command provisions all infrastructure components.'
        },
        {
          listname: '<span class="fw-medium">03 Automated Kubernetes Setup : </span> Automatically creates and configures EKS clusters with associated services.'
        },
        {
          listname: '<span class="fw-medium">04 CI/CD Integration : </span> Integrated AWS CodePipeline for seamless code deployment post-infrastructure setup.'
        },
        {
          listname: '<span class="fw-medium">05 Reusable & Scalable : </span> Deploys multiple environments effortlessly, reducing manual intervention.'
        },
      ],
      resultlist: [
        {
          listname: 'Error-free deployments completed in minutes instead of days.'
        },
        {
          listname: 'Scalable infrastructure for UAT, production, and client-specific needs.'
        },
        {
          listname: 'Significant cost and time savings.'
        },
        {
          listname: 'Fully automated CI/CD workflow with minimal manual effort.'
        },
      ],
      service: [
        {
          imgicon: Imageicon6,
          listname: "AWS CDK",
          width: 52, height: 60

        },
        {
          imgicon: Imageicon7,
          listname: "AWS EKS",
          width: 53, height: 60

        },
        {
          imgicon: Imageicon8,
          listname: "AWS CodePipeline",
          width: 52, height: 60

        },
        {
          imgicon: Imageicon10,
          listname: "AWS VPC",
          width: 50, height: 60

        }
      ]
    },
    {
      title: "Real-time driver matching & scalable data processing for taxi solution",
      tabId: "awstab4",
      des: "The client needed a system to handle:",
      list: [
        {
          listname: 'High-frequency data updates : Real-time driver location changes every few seconds'
        },
        {
          listname: 'Instant driver matching : Quickly find the nearest driver from dynamic data'
        },
        {
          listname: 'Scalability : Handle thousands of ride requests and millions of location updates'
        },
        {
          listname: 'Analytics : Generate reports without impacting real-time operations'
        },
      ],
      solutiondes: "We implemented a multi-database architecture with real-time data streaming and instant communication protocols:",
      solitionlistnew: [
        {
          title: "Optimized Data Storage:",
          list: [
            {
              name: "<span class='fw-medium'>Transaction Layer (Redis/MemSQL) : </span> Stores active rides and location data for instant driver matching."
            },
            {
              name: "<span class='fw-medium'>Reporting Layer (PostgreSQL/Redshift) : </span> Handles completed rides and analytics without affecting live data."
            },
            {
              name: "<span class='fw-medium'>Persistent Layer (DynamoDB/MongoDB) : </span> Manages static data (user profiles, driver details)."
            },
          ]
        },
        {
          title: "Real-Time Processing with Kafka:",
          list: [
            {
              name: "Kafka streams live driver location data."
            },
            {
              name: "Nearest driver found instantly through in-memory transaction layer queries."
            }
          ]
        },
        {
          title: "Instant Communication via MQTT:",
          list: [
            {
              name: "Enables real-time trip updates, ride statuses, and notifications between drivers, passengers, and backend systems."
            }
          ]
        },
        {
          title: "Independent Reporting System:",
          list: [
            {
              name: "Analytics include demand peaks, ride completion rates, surge pricing trends, and driver availability."
            },
            {
              name: "Reporting runs independently, ensuring uninterrupted live operations."
            }
          ]
        }
      ],

      resultlist: [
        {
          listname: 'Lightning-fast driver matching with real-time data processing.'
        },
        {
          listname: 'Optimized performance through layered data storage.'
        },
        {
          listname: 'Scalable architecture handling millions of location updates &requests.'
        },
        {
          listname: 'Real-time analytics without disrupting live services.'
        },
        {
          listname: 'Enhanced user experience with instant trip updates.'
        },
      ],
      service: [
        {
          imgicon: Imageicon12,
          listname: "Kafka",
          width: 37, height: 60

        },
        {
          imgicon: Imageicon14,
          listname: "Redis",
          width: 60, height: 60

        },
        {
          imgicon: Imageicon9,
          listname: "MQTT",
          width: 60, height: 60

        },
        {
          imgicon: Imageicon13,
          listname: "PostgreSQL",
          width: 57, height: 60
        },
        {
          imgicon: Imageicon4,
          listname: "DynamoDB",
          width: 60, height: 60
        },
        {
          imgicon: Imageicon11,
          listname: "Amazon Redshift",
          width: 54, height: 60

        }
      ]
    },
  ]
  const formUrl = typeof window !== 'undefined' ? window.location.pathname : '';
  // console.log("....formUrl......" , formUrl)

  return (
    <>

      <section className={`section aws-section ${sectionClass}`}>
        <Container className="py-5">
          <div className="mb-5 pb-1 max-width-950">
            <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: title }} />
            <p className="lead">{description}</p>
          </div>
          <Row className="g-5" xs={1} md={1}>
            <Col lg={4}>
              <div className="mb-5 pb-1 sticky-section">
                <Scrollspy offset={-500} className="list-unstyled left-line-list mb-5" items={['awstab1', 'awstab2', 'awstab3', 'awstab4']} currentClassName="active">
                  <li className="active">
                    <AnchorLink to={`${formUrl}#awstab1`}
                      stripHash>
                      Optimizing large file imports with AWS Lambda & SQS
                    </AnchorLink>
                  </li>
                  <li>
                    <AnchorLink to={`${formUrl}#awstab2`} stripHash>
                      Scalable PDF generation with AWS Lambda & S3
                    </AnchorLink>
                  </li>
                  <li>
                    <AnchorLink to={`${formUrl}#awstab3`} stripHash>
                      Automating Infrastructure Deployment with AWS CDK
                    </AnchorLink>
                  </li>
                  <li>
                    <AnchorLink to={`${formUrl}#awstab4`} stripHash>
                      Real-time driver matching & scalable data processing for taxi solution
                    </AnchorLink>
                  </li>
                </Scrollspy>
                <div className="pt0-5 mt-4 text-center0">
                  <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme">
                    Let’s solve your challenge
                  </Link>
                </div>
              </div>
            </Col>
            <Col className="text-lg-center0" lg={8}>
              {
                ReliableOffshore.map((item, index) => (
                  <div key={index}>
                    <h3 className="mb-4 pb-2 font-size-24">{item.title}</h3>
                    <div className="card mb-5" key={index} id={item.tabId}>
                      <div className={`card-body d-flex flex-column text-start mb-0 p-4`}  >
                        <h3 className="font-size-24 mb-4 position-relative">Challenge</h3>
                        <p className="mb-4">{item.des}</p>
                        <ul className="bullet-list">
                          {
                            item?.list?.map((item, index) => (
                              <li key={index}>{item.listname}</li>
                            ))
                          }
                        </ul>
                      </div>
                      <div className={`card-body d-flex flex-column text-start mb-0 bg-light p-4`}>
                        <h3 className="font-size-24 mb-4 position-relative">Solution</h3>
                        <p className="mb-4">{item.solutiondes}</p>
                        {
                          item?.solitionlist ?

                            <ul className="list-unstyled">
                              {
                                item?.solitionlist?.map((item, index, array) => (
                                  <li key={index} dangerouslySetInnerHTML={{ __html: item.listname }} className={`${index === array.length - 1 ? "mb-0" : "mb-3"}`}></li>
                                ))
                              }
                            </ul> :
                            <ul className="bullet-list">

                              {
                                item?.solitionlistnew?.map((item, index) => (
                                  <div className="mb-4" key={index}>
                                    <h4 className="mb-3">{item.title}</h4>
                                    {
                                      item.list?.map((item, index) => (
                                        <li key={index} dangerouslySetInnerHTML={{ __html: item.name }} className={`${index === 3 ? "mb-0" : "mb-3"}`}></li>
                                      ))
                                    }
                                  </div>
                                ))}
                            </ul>
                        }

                      </div>
                      <div className={`card-body d-flex flex-column text-start mb-0 p-4`}  >
                        <h3 className="font-size-24 mb-4 mb-4 position-relative">Result</h3>
                        <ul className="bullet-list">
                          {
                            item?.resultlist?.map((item, index) => (
                              <li key={index}>{item.listname}</li>
                            ))
                          }
                        </ul>
                      </div>
                      <div className={`card-body d-flex flex-column text-start mb-0 p-4 bg-light`}  >
                        <h3 className="font-size-24 mb-4 mb-4 position-relative">Key AWS services used</h3>
                        <Row xs="auto" className="g-4">
                          {
                            item?.service?.map((item, index) => (
                              <Col className="text-center" key={index} >
                                <div key={index} className="d-flex flex-column align-items-center">
                                  <div className="icon-size-60  mb-3">
                                    <Image loading="lazy" width={item.width} height={item.height} className="lazyload" src={item.imgicon} alt="TechnologiesIcon" />
                                  </div>
                                  <span>{item.listname}</span>
                                </div>
                              </Col>
                            ))
                          }
                        </Row>
                      </div>
                    </div>
                  </div>
                ))
              }
            </Col >
          </Row>
        </Container>
      </section>
    </>
  )

}

export default Usecaseaws;
